module.exports = __webpack_public_path__ + "static/media/otterSec.75a15e40.png";